import {
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Platform } from '@ionic/angular';
import { of, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';

import { CapacitorHttpService } from '../vendor/capacitor/capacitor-http.service';

export const capacitorHttpInterceptorFn: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const platform = inject(Platform);
  const capacitorHttp = inject(CapacitorHttpService);

  // Check if the app is running in a native environment
  if (!platform.is('capacitor')) {
    // Use Angular's default HttpClient for PWA or web mode
    return next(req);
  }

  // Use Capacitor's Http plugin for native environments
  return capacitorHttp.requestFromNgRequest(req).pipe(
    switchMap(response => {
      // CapacitorHttp resolves for any completed exchange, so surface 4xx/5xx as a
      // thrown HttpErrorResponse to drive Angular's error pipeline (as on web).
      if (response.status >= 400) {
        return throwError(
          () =>
            new HttpErrorResponse({
              error: response.data,
              headers: new HttpHeaders(response.headers),
              status: response.status,
              statusText: `${response.status}`,
              url: response.url,
            })
        );
      }
      // Convert the Capacitor response to an Angular HttpResponse
      return of(
        new HttpResponse({
          status: response.status,
          body: response.data,
          headers: new HttpHeaders(response.headers),
          url: response.url,
        })
      );
    }),
    catchError(error => {
      // Our >= 400 branch already threw a well-formed HttpErrorResponse; pass it through untouched.
      if (error instanceof HttpErrorResponse) {
        return throwError(() => error);
      }
      // Convert a transport-level (promise rejection) error to an Angular HttpErrorResponse
      return throwError(
        () =>
          new HttpErrorResponse({
            error: error.error || error.message,
            headers: req.headers,
            status: error.status || 0,
            statusText: error.statusText || 'Unknown Error',
            url: req.url,
          })
      );
    })
  );
};
